import {
  Card,
  Column,
  GridContainer,
  Icon,
  Li,
  Ol,
  Row,
  Typography,
  Ul,
} from '@vp/swan';
import React from 'react';

type ExpertCardProps = {
  title: String;
  messages: String[];
  orderedList?: boolean;
};

export const ExpertCard = ({
  title,
  messages,
  orderedList = false,
}: ExpertCardProps) => {
  const showList: boolean = messages.length > 1;

  const expertMessage = showList ? (
    <Ul>
      {messages.map(message => (
        <Li pb={0}>{message}</Li>
      ))}
    </Ul>
  ) : (
    <Typography ml={6}>{messages[0]}</Typography>
  );

  return (
    <Card bordered bgc="strong">
      <GridContainer>
        <Row>
          <Column span={12}>
            <Typography fontSkin="body-standard-bold">
              <Icon iconType="magic" aria-hidden="true" mr={1} /> {title}
            </Typography>
          </Column>
          <Column span={12}>
            {orderedList ? (
              <Ol>
                {messages.map(message => (
                  <Li pb={0} pl={0}>
                    {message}
                  </Li>
                ))}
              </Ol>
            ) : (
              expertMessage
            )}
          </Column>
        </Row>
      </GridContainer>
    </Card>
  );
};
